import * as React from 'react'
import has from 'lodash/has'
import { IHeaders } from './interface'

const Header = ({ className, level, title }: any) => {
  const h1 = () => <h1 {...{ className }}>{title}</h1>
  const h2 = () => <h2 {...{ className }}>{title}</h2>
  const h3 = () => <h3 {...{ className }}>{title}</h3>
  const h4 = () => <h4 {...{ className }}>{title}</h4>
  const HEADERS: IHeaders = { h1, h2, h3, h4 }
  const HEAD = level && has(HEADERS, level) ? HEADERS[level] : h1

  return <HEAD />
}

export default Header
